import * as React from 'react';
import { Patient } from '../../../models/core';
import InsuranceList from './insurance/InsuranceList';
import { Insurance } from '../../../models/insurance';

interface PatientInsuranceProps {
    patient?:Partial<Patient>;
    insurance?:Insurance[];
    onUpdate?:(list:Insurance[]) => void;
}

const PatientInsuranceView = ({ patient, insurance:initial, onUpdate }: PatientInsuranceProps): JSX.Element => {
    return  (
    <InsuranceList hasBorder={false} patient={patient||undefined} insurance={initial} controlled={true}
        onUpdate={(list) => {
            onUpdate && onUpdate(list);
        }
    }/>
    )
}

export default PatientInsuranceView;